var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoominfo = function SvgZoominfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 65"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoominfo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA1B15",
    d: "M.272 8.272a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.273 16.273h3.437c.311 0 .563.25.563.563v8.863a.57.57 0 0 1-.553.573h-2.884a.56.56 0 0 1-.563-.563v-2.593L22.038 44.273h5.671c.312 0 .564.251.564.563v2.873a.56.56 0 0 1-.564.564H16.837a.56.56 0 0 1-.563-.564v-3.437l25.203-24h-2.64a.56.56 0 0 1-.563-.563v-2.863c0-.312.25-.564.563-.564zm-20 4 9.436-.01a.56.56 0 0 0 .563-.564v-2.863a.56.56 0 0 0-.552-.563H16.856a.56.56 0 0 0-.563.563v8.873c0 .312.25.564.563.564h2.863a.554.554 0 0 0 .553-.564v-5.436zm20 24H32.836a.56.56 0 0 0-.563.563v2.873c0 .312.25.564.563.564H47.71a.56.56 0 0 0 .563-.564v-8.92a.56.56 0 0 0-.563-.563h-2.874a.56.56 0 0 0-.563.563z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zoominfo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.272.272h64v64h-64z"
  })))));
};
export default SvgZoominfo;